module.exports = __webpack_public_path__ + "img/28200.141a8987.jpg";